'use strict';

var React = require('react');
var cell = require('./Cells/cell.js');
require('./Cells/cellActions.js');
require('./Cells/cellCheckbox.styles.js');
require('../Chip/component.js');
require('../Tooltip/component.js');
require('./Cells/cellIcon.styles.js');
require('../Pill/pill.styles.js');
require('../Pill/pillButton.styles.js');
require('../forms/Select/Control.js');
require('../forms/Select/Option.js');
require('../forms/Select/multi-select/OptionMulti.js');
require('../forms/Select/multi-select/ControlMulti.js');
require('./Cells/cellSubText.styles.js');
require('../forms/Switch/component.js');
require('../Tag/component.js');
require('./Cells/header.js');
require('../Icon/component.js');
var row = require('./row.js');
var row_styles = require('./row.styles.js');
var table_styles = require('./table.styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const LoadingState = ({ id, columns, page, itemsPerPage, total, }) => {
    let remainingItemsCount = total - itemsPerPage * page;
    if (page && remainingItemsCount < 0) {
        // This behavior is not supposed to happen if component is correctly used, but since that's not always the case...
        // That's the reason why we intentionally left a console.warning message, so the developer could fix it in their code
        console.warn('<LoadingState/> Fixing remainingItemsCount value automatically - you should use tableEngine methods in the correct order');
        remainingItemsCount = total;
    }
    const loadingItems = page > 0 && total > 0 ? Math.min(remainingItemsCount, itemsPerPage) : itemsPerPage;
    return (React__default.default.createElement(React__default.default.Fragment, null, Array(loadingItems)
        .fill(0)
        .map((d, dataIndex) => (React__default.default.createElement(row.Row, { "$isAlt": dataIndex % 2 !== 0, key: `${page}-${dataIndex}`, id: `${id}-row-${dataIndex}` }, columns.map((c, colIndex) => (React__default.default.createElement(cell.Cell, { key: `${c.key}-${dataIndex}`, id: `${id}-cell-${dataIndex}-${colIndex}` },
        React__default.default.createElement(table_styles.FillingDiv, { style: { width: `${(Math.abs(Math.sin(dataIndex + colIndex)) * (1 - 0.25) + 0.25) * 100}%` } })))))))));
};
const EmptyStateRow = ({ columns, labelEmptySub, labelEmptyTitle, }) => (React__default.default.createElement(row_styles.TableRowStyled, { "$isAlt": false, "$noHover": true },
    React__default.default.createElement(table_styles.EmptyCell, { colSpan: columns.length },
        React__default.default.createElement("div", null, labelEmptyTitle),
        React__default.default.createElement(table_styles.EmptyCellSecondaryText, null, labelEmptySub))));
const defaultLabelEmptyTitle = 'Oops, aucun résultat ne correspond à votre recherche';
const defaultLabelEmptySub = 'Nous vous invitons à effectuer une nouvelle recherche';
const TableData = ({ engine, total, itemsPerPage, page, columns, id, onRowClick, makeHandleFocusForRow, getRowOptions, labelEmptyTitle = defaultLabelEmptyTitle, labelEmptySub = defaultLabelEmptySub, renderExpandedRow, }) => {
    if (engine.state.isLoading) {
        return React__default.default.createElement(LoadingState, { id: id, columns: columns, page: page, itemsPerPage: itemsPerPage, total: total });
    }
    if (engine.state.data.length === 0) {
        return (React__default.default.createElement(EmptyStateRow, { columns: columns, itemsPerPage: itemsPerPage, labelEmptyTitle: labelEmptyTitle, labelEmptySub: labelEmptySub }));
    }
    return (React__default.default.createElement(React__default.default.Fragment, null, engine.state.data.map((d, dataIndex) => (React__default.default.createElement(row.Row, { "$isAlt": dataIndex % 2 !== 0, "$isClickable": !!onRowClick, key: d[engine.state.keyField], id: `${id}-row-${dataIndex}`, tabIndex: 0, onFocus: makeHandleFocusForRow(d), onClick: () => onRowClick?.(d), "$mode": getRowOptions?.(d).mode, data: d, columnsCount: columns.length, isExpanded: engine.state.expandedRows.includes(d[engine.state.keyField]), "$isSelected": engine.state.selectedRows.includes(d[engine.state.keyField]), renderExpandedRow: renderExpandedRow }, columns.map((c, colIndex) => {
        const renderCellProps = {
            id: `${id}-cell-${dataIndex}-${colIndex}`,
            className: `ds-iziwork-col-${c.key}`,
            important: c.important,
        };
        let cellElement;
        if (c.field) {
            cellElement = React__default.default.createElement(cell.Cell, { ...renderCellProps }, d[c.field]);
        }
        if (c.cell) {
            const renderCell_legacy = c.cell;
            cellElement = renderCell_legacy({ ...renderCellProps, data: d });
        }
        if (c.renderCell) {
            const renderCell = c.renderCell;
            cellElement = renderCell(d, renderCellProps);
        }
        if (cellElement) {
            return React__default.default.createElement(React.Fragment, { key: `${c.key}-${d[engine.state.keyField]}` }, cellElement);
        }
    }))))));
};

exports.TableData = TableData;
//# sourceMappingURL=tableData.js.map
